
import { abrirGovbr } from 'login/actions';
import './toolbar.css';
import './btnentrar.css';

const BtnEntrar = () => {

  return (
    <button
      className="br-sign-in primary"
      type="button"
      aria-label="Entrar com gov br"
      title="Entrar com com govbr"
      onClick={abrirGovbr} 
    >
      <i className="fas fa-user ml-2" aria-hidden="true"></i>
      <span className="mr-2 text-weight-regular">Entrar</span>
    </button>
  )
}

export default BtnEntrar;